<template>
  <div>
    <iframe
      id="modle_iframe"
      :key="ikey"
      ref="Iframe"
      :src="url"
      width="100%"
      height="100%"
      frameborder="0"
    />
  </div>
</template>

<script>
import CarApi from "@/api/car";

export default {
  name: "CarLocation",
  data() {
    return {
      url: "",
      ikey: "",
      type: "0",
      carNo: "",
      date: "",
    };
  },

  created() {
    // console.log(this.$route.query);
    if (this.$route.query.date) {
      this.date = this.$route.query.date;
    }
    if (this.$route.query.no) {
      this.carNo = this.$route.query.no;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
  },
  mounted() {
    // 暂时设置根据tenantId关闭演示账号获取url
    if (JSON.parse(localStorage.getItem("userInfo")).tenantId !== 2) {
      this.getUrl();
    } else {
      this.$message.warning("演示账号暂时禁止使用");
    }
  },
  methods: {
    getUrl() {
      CarApi.urlDirect({
        carNum: this.carNo,
        date: this.date,
        isQueryByTime: 0,
        timeFrom: "",
        timeTo: "",
        urlType: this.type,
        vkey: "",
      }).then((res) => {
        // console.log(res);
        this.url = res.data.data;
        this.ikey = new Date().getTime();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
